import { Search } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SearchIcon = createLucideIcon(Search);
